import { combineReducers } from 'redux';

import { TRIGGER_KEYLOOP_REFRESH } from 'modules/dealers/actionTypes';
import loading from 'modules/global/reducers/generic.loading';

import dmsProvider from './dmsProvider';
import smsProvider from './smsProvider';

/**
 * @typedef {{
 *   smsProvider: import('./smsProvider').DealerConfigurationIntegrationsSmsProviderReducer,
 *   dmsProvider: import('./dmsProvider').DealerConfigurationIntegrationsDmsProviderReducer,
 *   keyloop: {
 *     refresh: boolean,
 *   },
 * }} DealerConfigurationIntegrationsReducer
 */

export default combineReducers({
  smsProvider,
  dmsProvider,
  keyloop: combineReducers({
    refresh: loading(TRIGGER_KEYLOOP_REFRESH),
  }),
});
